import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import { GET_DEEP_LINK } from 'store/deepLink/actionTypes';
import { createProcessingSelector } from 'store/loading/selectors';

import { useSelector } from 'hooks';

import ScanIcon from 'assets/img/scan-icon-phone.svg';

import ScanQrCode from '../ScanQrCode';

import * as S from './styled';

const DownloadWithQrCode = ({ deepLinkUrl }: { deepLinkUrl: string }) => {
    const isLoading: boolean = useSelector(createProcessingSelector([GET_DEEP_LINK]));

    const { t } = useTranslation();

    return (
        <S.DownloadWrapper>
            <S.DownloadDescription>
                <S.IconWrapper>
                    <ScanIcon />
                </S.IconWrapper>
                <Text mb={56} center>
                    {t('main.step.title.scanCode')}
                </Text>
            </S.DownloadDescription>
            <ScanQrCode isLoading={isLoading} deepLinkUrl={deepLinkUrl} />
        </S.DownloadWrapper>
    );
};

export default DownloadWithQrCode;
